<div class="public-events-page container">
  @if (error()) { <div class="alert alert-danger" role="alert">{{ error() }}</div> }
  @if (message()) { <div class="alert alert-success" role="status">{{ message() }}</div> }

  <div class="card">
    <div class="card-header">Events</div>
    <div class="card-body">
      <p class="intro">
        Department of Higher Education scholarship events that are open to the public. Register below and
        we will email you the details once your signup is confirmed.
      </p>

      @if (loading()) {
        <div class="empty-state">Loading events…</div>
      } @else if (events().length === 0) {
        <div class="empty-state">
          <i class="fas fa-calendar-alt"></i>
          <h3>No public events right now</h3>
          <p>Please check back later for upcoming events.</p>
        </div>
      } @else {
        <ul class="event-list">
          @for (event of events(); track event.id) {
            <li class="event-item">
              <div class="event-main">
                <h3>{{ event.title }}</h3>
                <p class="muted">
                  <i class="fas fa-calendar"></i> {{ event.startDate | date: 'yyyy-MM-dd HH:mm' }}
                  @if (event.location) { · <i class="fas fa-map-marker-alt"></i> {{ event.location }} }
                </p>
                @if (event.sessionCount > 0) {
                  <p class="muted">{{ event.sessionCount }} attendance option(s) — choose one when you register.</p>
                }
              </div>
              <div class="event-actions">
                <button type="button" class="btn btn-primary btn-sm" (click)="open(event)">
                  <i class="fas fa-check"></i> Register
                </button>
              </div>
            </li>
          }
        </ul>
      }
    </div>
  </div>

  @if (selected(); as event) {
    <div class="card signup-card">
      <div class="card-header">
        {{ event.title }}
        <button type="button" class="btn btn-secondary btn-sm panel-close" (click)="close()">Close</button>
      </div>
      <div class="card-body">
        @if (event.description) { <p>{{ event.description }}</p> }

        <div class="event-summary">
          <div>
            <span class="muted">When</span>
            <strong>{{ event.startDate | date: 'yyyy-MM-dd HH:mm' }} → {{ event.endDate | date: 'yyyy-MM-dd HH:mm' }}</strong>
          </div>
          <div><span class="muted">Venue</span><strong>{{ event.location || 'To be confirmed' }}</strong></div>
        </div>

        @if (event.sessions.length > 0) {
          <div class="sessions">
            <h4>Attendance options</h4>
            @for (session of event.sessions; track session.id) {
              <label class="checkbox-line">
                <input type="radio" name="public-session" [checked]="form.controls.sessionId.value === session.id"
                  (change)="form.controls.sessionId.setValue(session.id)" />
                <span>
                  {{ session.title || 'Option' }} — {{ session.startDate | date: 'yyyy-MM-dd HH:mm' }}
                  to {{ session.endDate | date: 'HH:mm' }}
                </span>
              </label>
            }
          </div>
        }

        @if (canSignUp(event)) {
          <form class="signup-form" [formGroup]="form" (ngSubmit)="submit()">
            <div class="form-grid">
              <label>
                Full name *
                <input class="form-control" formControlName="fullName" />
              </label>
              <label>
                Email address *
                <input type="email" class="form-control" formControlName="emailAddress" />
              </label>
            </div>
            <div class="form-actions">
              <button type="submit" class="btn btn-primary" [disabled]="busy()">Sign up</button>
              <button type="button" class="btn btn-secondary" (click)="close()">Cancel</button>
            </div>
          </form>
        } @else {
          <div class="alert" role="status">
            Registration for this event has closed. Please contact the department for assistance.
          </div>
        }
      </div>
    </div>
  }
</div>
